import { render, staticRenderFns } from "./Product2.vue?vue&type=template&id=c12f008c&scoped=true&"
import script from "./Product2.vue?vue&type=script&lang=js&"
export * from "./Product2.vue?vue&type=script&lang=js&"
import style0 from "./Product2.vue?vue&type=style&index=0&id=c12f008c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12f008c",
  null
  
)

export default component.exports